export default __webpack_public_path__ + "static/media/Group704.b15230c3.svg";